//@flow
export const Page = {
  PANTRY: 'pantry',
  PERKS: 'work-from-home-snack-perks',
  EVENTS: 'virtual-events',
  WELLNESS: 'wellness-programs',
  APPRECIATION: 'client-employee-appreciation',
  GIFTING: 'corporate-gifting',
  SALES: 'sales-prospecting',
  MEETINGS: 'virtual-meetings',
  CATERING: 'catering',
};

export const SubPageLinks = [
  {
    label: 'Snack Perks',
    link: `/office/${Page.PERKS}`,
  },
  {
    label: 'Virtual Events',
    link: `/office/${Page.EVENTS}`,
  },
  {
    label: 'Wellness Programs',
    link: `/office/${Page.WELLNESS}`,
  },
  {
    label: 'Appreciation',
    link: `/office/${Page.APPRECIATION}`,
  },
  {
    label: 'Corporate Gifting',
    link: `/office/${Page.GIFTING}`,
  },
  {
    label: 'Sales Prospecting',
    link: `/office/${Page.SALES}`,
  },
  {
    label: 'Virtual Meetings',
    link: `/office/${Page.MEETINGS}`,
  },
  {
    label: 'Catering',
    link: `/office/${Page.CATERING}`,
  },
];
